import React, { useState, useEffect } from 'react';

const Resultados = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // --- FRASES EXATAS DA ARTE (NÃO ALTERAR) ---
  const beneficios = [
    "Melhora a mobilidade e saúde das articulações.",
    "Fortalece ossos e dentes.",
    "Promove músculos fortes e pelagem saudável.",
    "Ajuda no bem-estar e equilíbrio emocional.",
    "Contribui para energia, foco e vitalidade.",
    "Mantém pele e pelos bonitos e resistentes.",
    "Fortalece a imunidade e disposição diária.",
    "Favorece a digestão e o metabolismo."
  ];

  return (
    <section style={styles.section}>
      <div className="container" style={styles.container}>
        
        {/* --- CABEÇALHO --- */}
        <div style={{marginBottom: '50px'}}>
            <h2 style={styles.title}>
              POR QUE A GUMMY É ÚNICA?
            </h2>
            <p style={styles.subtitle}>
              Resultados visíveis e progressivos.
            </p>
        </div>

        {/* --- TABELA COMPARATIVA --- */}
        <div style={styles.tableContainer}>
          
          {/* CABEÇALHO DA TABELA (Desktop) */}
          {!isMobile && (
            <div style={styles.headerRow}>
              <div style={{...styles.headerCell, width: '50%', textAlign: 'left', paddingLeft: '30px', color: '#555'}}>
                Benefícios
              </div>
              <div style={{...styles.headerCell, width: '25%', backgroundColor: '#5D2E8C', color: '#fff', borderRadius: '15px 15px 0 0'}}>
                Com a Gummy<br/>24 em 1
              </div>
              <div style={{...styles.headerCell, width: '25%', color: '#999'}}>
                Sem a Gummy<br/>24 em 1
              </div>
            </div>
          )}

          {/* LISTA DE BENEFÍCIOS */}
          <div style={styles.rowsContainer}>
            {beneficios.map((item, index) => (
              <div key={index} style={{
                  ...styles.row, 
                  backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9', // Listrado suave
                  flexDirection: isMobile ? 'column' : 'row',
                  gap: isMobile ? '10px' : '0'
              }}>
                
                {/* TEXTO DO BENEFÍCIO */}
                <div style={{
                    ...styles.cell, 
                    width: isMobile ? '100%' : '50%', 
                    textAlign: isMobile ? 'center' : 'left',
                    justifyContent: isMobile ? 'center' : 'flex-start',
                    paddingLeft: isMobile ? '0' : '30px',
                    fontWeight: '600',
                    color: '#444'
                }}>
                  {item}
                </div>

                {/* COLUNA: COM A GUMMY (Check Verde) */}
                <div style={{
                    ...styles.cell, 
                    width: isMobile ? '100%' : '25%', 
                    backgroundColor: isMobile ? '#F0E6FA' : 'rgba(93, 46, 140, 0.05)', 
                    borderRadius: isMobile ? '10px' : '0'
                }}>
                  {isMobile && <span style={{fontSize: '0.8rem', fontWeight: 'bold', color: '#5D2E8C', marginBottom: '5px'}}>Com Gummy: </span>}
                  <div style={styles.checkIcon}>✔</div>
                </div>

                {/* COLUNA: SEM A GUMMY (X Cinza/Vermelho) */}
                <div style={{
                    ...styles.cell, 
                    width: isMobile ? '100%' : '25%'
                }}>
                   {isMobile && <span style={{fontSize: '0.8rem', fontWeight: 'bold', color: '#999', marginBottom: '5px'}}>Sem Gummy: </span>}
                  <div style={styles.crossIcon}>✖</div>
                </div>

              </div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 20px',
    backgroundColor: '#fff', 
    textAlign: 'center'
  },
  container: {
    maxWidth: '1000px',
    margin: '0 auto'
  },
  title: {
    color: '#5D2E8C',
    fontSize: '2.5rem',
    fontFamily: '"Titan One", sans-serif',
    marginBottom: '10px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    lineHeight: '1.2'
  },
  subtitle: {
    color: '#32CD32', // Verde
    fontFamily: '"Commissioner", sans-serif',
    fontSize: '1.5rem',
    fontWeight: '700',
    marginBottom: '40px'
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 15px 40px rgba(0,0,0,0.08)',
    borderRadius: '20px',
    overflow: 'hidden',
    border: '1px solid #eee'
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: '800',
    fontSize: '1.1rem',
    fontFamily: '"Montserrat", sans-serif',
    paddingBottom: '0'
  },
  headerCell: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '80px' 
  },
  rowsContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '15px 0',
    borderBottom: '1px solid #eee'
  },
  cell: {
    display: 'flex',
    flexDirection: 'column', 
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: '"Commissioner", sans-serif',
    fontSize: '1rem',
    padding: '10px'
  },
  checkIcon: {
    backgroundColor: '#32CD32',
    color: '#fff',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    boxShadow: '0 4px 10px rgba(50, 205, 50, 0.3)'
  },
  crossIcon: {
    color: '#ccc',
    fontSize: '1.6rem',
    fontWeight: 'bold'
  }
};

export default Resultados;